import { create } from "zustand";
import { persist } from "zustand/middleware";

const useLanguageStore = create(
  persist(
    (set) => ({
      language: "zh", // 默认中文
      setLanguage: (lang) => set({ language: lang }),
      toggleLanguage: () =>
        set((state) => ({
          language: state.language === "zh" ? "en" : "zh",
        })),
    }),
    {
      name: "language-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useLanguageStore;

